/**
 * EmailJS keys from `.env` (Create React App: must start with REACT_APP_).
 * Restart dev server after changing env vars.
 */
export type EmailJsPublicConfig = {
  serviceId: string
  templateId: string
  publicKey: string
}

const ENV_SERVICE = "REACT_APP_EMAILJS_SERVICE_ID"
const ENV_TEMPLATE = "REACT_APP_EMAILJS_TEMPLATE_ID"
const ENV_PUBLIC = "REACT_APP_EMAILJS_PUBLIC_KEY"

export function getEmailJsMissingKeys(): string[] {
  const missing: string[] = []
  if (!process.env.REACT_APP_EMAILJS_SERVICE_ID?.trim()) missing.push(ENV_SERVICE)
  if (!process.env.REACT_APP_EMAILJS_TEMPLATE_ID?.trim()) missing.push(ENV_TEMPLATE)
  if (!process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim()) missing.push(ENV_PUBLIC)
  return missing
}

export function getEmailJsConfig(): EmailJsPublicConfig | null {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID?.trim() ?? ""
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID?.trim() ?? ""
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim() ?? ""
  if (!serviceId || !templateId || !publicKey) return null
  return { serviceId, templateId, publicKey }
}
